export interface INotificationResponse {
  date: string;
  description: string;
  id: number;
  image: string;
  link: string;
  tag: string;
  title: string;
  lido: boolean;
  btnText?: string;
}

export enum ENotification {
  notification = "notification"
}

export default class Novidade {
  constructor(readonly response: INotificationResponse[] | undefined) {}
}
